import type { Recommendation } from "../../../state/governance";

/** Only recorded proposals belong in Changes; never invent a previous version. */
export function suggestionChangeRows(suggestion: Pick<Recommendation, "proposedChange">) {
  const labels: ReadonlyArray<readonly [string, string]> = [
    ["title", "Title"],
    ["amendment", "Proposed wording"],
    ["contextAddition", "Wording to add"],
    ["section", "Section"],
    ["controlCode", "Control"],
    ["controlAction", "Action"],
    ["controlId", "Control ID"],
    ["reviewFrequency", "Review cadence"],
    ["ownerEmails", "Owners"],
    ["department", "Department"],
    ["jurisdictionSlugs", "Jurisdictions"],
    ["documentKind", "Document type"],
    ["implementsPolicyId", "Implements policy"],
    ["frameworkName", "Framework"],
    ["frameworkId", "Framework ID"],
  ];
  const change = suggestion.proposedChange as Record<string, unknown>;
  return labels.flatMap(([key, label]) => {
    if (
      key === "frameworkId" &&
      typeof change.frameworkName === "string" &&
      change.frameworkName.trim()
    )
      return [];
    const raw = change[key];
    if (
      raw === null &&
      (key === "frameworkId" || key === "department" || key === "implementsPolicyId")
    )
      return [{ key, label, value: "None" }];
    if (
      Array.isArray(raw) &&
      raw.length === 0 &&
      (key === "ownerEmails" || key === "jurisdictionSlugs")
    ) {
      return [
        {
          key,
          label,
          value:
            key === "ownerEmails"
              ? "No owners proposed; at least one is required."
              : "No jurisdictions",
        },
      ];
    }
    const value =
      typeof raw === "string"
        ? raw.trim()
        : Array.isArray(raw)
          ? raw
              .filter((item): item is string => typeof item === "string" && item.trim().length > 0)
              .join(", ")
          : "";
    return value ? [{ key, label, value }] : [];
  });
}

/** Shared attribution for the conversation and details panel. */
export function suggestionSourceLabel(source: Recommendation["source"]): string {
  return source === "inspector" ? "Inspector" : source === "agent" ? "Amoreg" : "A team member";
}
